module.exports = __webpack_public_path__ + "static/media/5.ed8bdc6c.svg";